'use client';
var classes = {"dropdown":"m_88b62a41","options":"m_b2821a6e","option":"m_92253aa5","search":"m_985517d8","empty":"m_2530cd1d","header":"m_858f94bd","footer":"m_82b967cb","group":"m_254f3e4f","groupLabel":"m_2bb2e9e5","chevron":"m_2943220b","optionsDropdownOption":"m_390b5f4","optionsDropdownCheckIcon":"m_8ee53fc2"};

export { classes as default };
//# sourceMappingURL=Combobox.module.css.mjs.map
